import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const styles: any = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
        },
    }),
);

export default styles;
